import { useEffect, useRef, useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";

const ROWS = "table tbody tr:not(.po-total)";

function apply(root, q) {
  const words = q.trim().toLowerCase().split(/\s+/).filter(Boolean);
  root.querySelectorAll(ROWS).forEach((tr) => {
    if (tr.closest("[data-search-ignore]") || tr.querySelector("td[colspan]")) return;
    const hit = !words.length || words.every((w) => tr.textContent.toLowerCase().includes(w));
    tr.style.display = hit ? "" : "none";
  });
}

export function PageSearch({ placeholder = "Search…", testId = "page-search" }) {
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current?.closest("main") || document.body;
    apply(root, q);
    const obs = new MutationObserver(() => apply(root, q));
    obs.observe(root, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, [q]);
  return (
    <div ref={ref} className="relative w-full sm:w-64">
      <Search className="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" />
      <Input data-testid={testId} value={q} onChange={(e) => setQ(e.target.value)} placeholder={placeholder} className="pl-8 pr-8" />
      {q && <button data-testid={`${testId}-clear`} aria-label="Clear search" onClick={() => setQ("")} className="absolute right-2 top-2.5 text-slate-400 hover:text-slate-700"><X className="h-4 w-4" /></button>}
    </div>);
}
